<template>
  <div id="enter-box" class="main-content" tabindex="-1" style="outline: none">
    <Form :model="searchObj" label-position="top" inline>
      <FormItem prop="invoice_type">
        <i-select
          v-model="searchObj.invoice_type"
          filterable
          placeholder="请选择发票"
          clearable
          multiple
        >
          <i-option
            v-for="(item, index) in formData.invoice_type"
            :label="item"
            :value="index"
            :key="index"
          ></i-option>
        </i-select>
      </FormItem>

      <FormItem prop="invoice_form">
        <i-select
          v-model="searchObj.invoice_form"
          filterable
          placeholder="请选择发票类型"
          clearable
          multiple
        >
          <i-option
            v-for="(item, index) in formData.invoice_form"
            :label="item"
            :value="index + 1"
            :key="index"
          ></i-option>
        </i-select>
      </FormItem>

      <FormItem prop="vendor_name">
        <Input
          v-model.trim="searchObj.vendor_name"
          style="width: 200px"
          clearable
          placeholder="供应商"
        ></Input>
      </FormItem>
      <FormItem prop="settlement_id">
        <Input
          v-model.trim="searchObj.settlement_id"
          style="width: 200px"
          clearable
          placeholder="结算单"
        ></Input>
      </FormItem>
      <FormItem prop="pay_apply_id">
        <Input
          v-model.trim="searchObj.pay_apply_id"
          style="width: 200px"
          clearable
          placeholder="付款申请单"
        ></Input>
      </FormItem>
      <FormItem prop="invoice_number">
        <Input
          v-model.trim="searchObj.invoice_number"
          style="width: 200px"
          clearable
          placeholder="发票号"
        ></Input>
      </FormItem>
      <FormItem prop="approve_status">
        <i-select
          v-model="searchObj.approve_status"
          filterable
          multiple
          placeholder="审批状态"
          clearable
        >
          <i-option
            v-for="(item, index) in formData.approve_status"
            :label="item"
            :value="index"
            :key="index"
          ></i-option>
        </i-select>
      </FormItem>

      <FormItem prop="comment">
        <Input
          v-model.trim="searchObj.comment"
          style="width: 200px"
          clearable
          placeholder="备注"
        ></Input>
      </FormItem>

      <FormItem prop="create_user_name">
        <Input
          v-model.trim="searchObj.create_user_name"
          style="width: 200px"
          clearable
          placeholder="创建人"
        ></Input>
      </FormItem>

      <FormItem prop="date_range">
        <DatePicker
          type="daterange"
          :value="searchObj.date_range"
          format="yyyy-MM-dd"
          placeholder="创建时间"
          @on-change="searchObj.date_range = $event"
          ref="date_range"
        ></DatePicker>
      </FormItem>

      <FormItem>
        <Button
          icon="android-search"
          type="primary"
          :loading="loading"
          @click="search"
        >
          查询
        </Button>
        <Button style="margin-left: 10px" @click="clear"> 清空 </Button>
      </FormItem>
    </Form>

    <Row>
      <Col span="24">
        <Button type="primary" @click="addNewVoice"> 新增发票 </Button>

        <a
          id="exportAll"
          style="postion: absolute; left: 100%; width: 0px; height: 0px"
        ></a>
        <Button type="primary" style="float: right" @click="export_list">
          导出
        </Button>
      </Col>
    </Row>

    <!-- 表单 -->
    <Table
      :loading="loading"
      border
      :columns="columns"
      :data="formList"
    ></Table>

    <!-- 分页 -->
    <Page
      :total="total"
      :current="searchObj.page"
      show-total
      show-sizer
      show-elevator
      :page-size="searchObj.numb"
      placement="top"
      @on-change="pageChange"
      @on-page-size-change="pagesizeChange"
    ></Page>
  </div>
</template>

<script>
import qs from "qs";
import { constants } from "fs";
export default {
  name: "invoice-management",
  data() {
    return {
      loading: false, // List loading
      searchObj: {
        invoice_type: [],
        invoice_form: [],
        vendor_name: "",
        settlement_id: "",
        invoice_number: "",
        approve_status: [],
        comment: "",
        create_user_name: "",
        created_at_start: "",
        created_at_end: "",
        date_range: "",
        page: 1,
        page_num: 10,
      },
      formData: {
        invoice_type: ["国内发票", "境外invoice", "机票行程单", "收据"],
        invoice_form: ["纸质", "电子"],
        approve_status: ["待审批", "已审批", "已驳回"],
      },
      api_info: {},
      total: 0,
      formList: [],
      columns: [
        {
          title: "发票类型",
          key: "invoice_type",
          minWidth: 90,
        },
        {
          title: "发票形式",
          key: "invoice_form",
          minWidth: 75,
        },
        {
          title: "供应商",
          key: "vendor_name",
          minWidth: 80,
        },
        {
          title: "结算单",
          key: "settlement_code",
          minWidth: 70,
        },
        {
          title: "发票号",
          key: "invoice_number",
          minWidth: 80,
        },
        {
          title: "发票金额",
          key: "invoice_amount",
          minWidth: 90,
        },
        {
          title: "发票币种",
          key: "invoice_currency",
          minWidth: 75,
        },
        {
          title: "备注",
          key: "comment",
          minWidth: 80,
        },
        {
          title: "创建日期",
          key: "created_at",
          minWidth: 100,
        },
        {
          title: "创建人",
          key: "create_user_name",
          minWidth: 70,
        },
        {
          title: "审批状态",
          key: "approve_status",
          minWidth: 75,
        },
        {
          title: "操作",
          minWidth: 140,
          fixed: "right",
          render: (h, params) =>
            h("div", [
              h(
                "a",
                {
                  props: { disabled: !params.row.button.info },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: "man-invoice-info",
                        query: { invoice_id: params.row.id },
                      });
                    },
                  },
                },
                "查看"
              ),
              h(
                "a",
                {
                  props: {
                    type: "text",
                    size: "small",
                    disabled: !params.row.button.info,
                  },
                  style: {
                    marginRight: "5px",
                    color: params.row.button.approve ? "" : "gray",
                    pointerEvents: params.row.button.approve ? "" : "none",
                  },
                  on: {
                    click: () => {
                      this.http
                        .post(
                          this.apiUrl.invoiceApprove,
                          qs.stringify({ invoice_id: Number(params.row.id) })
                        )
                        .then((ele) => {
                          this.$Notice.success({ title: "审批成功" });
                          this.getList();
                        });
                    },
                  },
                },
                "审批"
              ),
              h(
                "a",
                {
                  style: {
                    marginRight: "5px",
                    color: params.row.button.reject ? "" : "gray",
                    pointerEvents: params.row.button.reject ? "" : "none",
                  },
                  on: {
                    click: () => {
                      this.http
                        .post(
                          this.apiUrl.invoiceReject,
                          qs.stringify({ invoice_id: Number(params.row.id) })
                        )
                        .then((ele) => {
                          this.$Notice.success({ title: "驳回成功" });
                          this.getList();
                        });
                    },
                  },
                },
                "驳回"
              ),
              h(
                "a",
                {
                  style: {
                    marginRight: "5px",
                    color: params.row.button.cancel ? "" : "gray",
                    pointerEvents: params.row.button.cancel ? "" : "none",
                  },
                  on: {
                    click: () => {
                      this.http
                        .post(
                          this.apiUrl.invoiceCancel,
                          qs.stringify({ invoice_id: Number(params.row.id) })
                        )
                        .then((ele) => {
                          this.$Notice.success({ title: "取消成功" });
                          this.getList();
                        });
                    },
                  },
                },
                "取消"
              ),
            ]),
        },
      ],
    };
  },

  watch: {
    $route() {
      if (this.$route.name == "invoice-management") {
        this.getList();
      }
    },
  },

  methods: {
    addNewVoice() {
      this.$router.push({ name: "man-add-invoice" });
    },

    // 清空
    clear() {
      this.searchObj = {
        vendor_name: "",
        sb_id: null,
        sb_mode: "",
        sb_period: "",
        date_range: ["", ""],
        finish_time: "",
        sb_state: "",
        operator: "",
        page: 1,
        numb: 10,
      };
    },

    // 搜索
    search() {
      this.searchObj.page = 1;
      this.getList();
    },

    // 页数切换
    pageChange(page) {
      this.searchObj.page = page;
      this.getList();
    },

    // 每页数量
    pagesizeChange(pagesize) {
      this.searchObj.page_num = pagesize;
      this.searchObj.page = 1;
      this.getList();
    },

    // 获取列表
    getList() {
      const searchObj = JSON.parse(JSON.stringify(this.searchObj));
      searchObj.created_at_start = searchObj.date_range[0];
      searchObj.created_at_end = searchObj.date_range[1];
      delete searchObj.date_range;
      for (const i in searchObj) {
        if (!searchObj[i] && searchObj[i] !== 0) {
          delete searchObj[i];
        }
      }
      this.loading = true;
      this.http
        .get(this.apiUrl.getInvoiceList, searchObj)
        .then((res) => {
          if (Array.isArray(res)) {
            this.formList = [];
            this.total = 0;
            this.loading = false;
            return;
          }
          this.loading = false;
          this.formList = res.list;
          this.total = Number(res.total);
        })
        .catch((res) => {
          this.loading = false;
        });
    },

    // 导出结算单
    export_list() {
      this.$Spin.show();

      // 导出结算单列表
      const searchObj = JSON.parse(JSON.stringify(this.searchObj));
      searchObj.created_at_start = searchObj.date_range[0];
      searchObj.created_at_end = searchObj.date_range[1];
      delete searchObj.date_range;
      for (const i in searchObj) {
        if (!searchObj[i] && searchObj[i] !== 0) {
          delete searchObj[i];
        }
      }
      this.http
        .get(this.apiUrl.invoiceExport, searchObj)
        .then((res) => {
          const columns = [].concat(this.columns);
          columns.pop();
          this.util.exportExcel(columns, res, "exportAll", "应付发票");
        })
        .finally((ele) => {
          this.$Spin.hide();
        });
    },
  },

  created() {
    this.getList();
  },

  mounted() {
    const _this = this;
    document.getElementById("enter-box").onkeyup = (e) => {
      if (!e) {
        e = window.event;
      }
      if ((e.keyCode || e.which) == 13) {
        _this.search();
      }
    };
  },
};
</script>

<style lang="less"></style>
